import React from "react";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import Button from "../controls/button";
import { openDrawer } from "../../store/features/drawer/drawer-slice";
import { DrawerID } from "../../constants/drawer-constants";

interface OrderSummaryButtonProps {
  orderId: number;
}

const OrderSummaryButton: React.FC<OrderSummaryButtonProps> = ({ orderId }) => {
  const dispatch = useAppDispatch();

  const handleOrderSummary = () => {
    dispatch(
      openDrawer({
        id: DrawerID.OrderSummary,
        anchor: "right",
        data: {
          orderId: orderId,
          headerText: "Order Summary"
        }
      })
    );
  };

  return (
    <Button
      variant="contained"
      id="btnOrderSummary"
      label="Order Summary"
      onClick={handleOrderSummary}
    />
  );
};

export default OrderSummaryButton;